export function mapSortedHeaders(selector) {
  const headers = selector?.[0]?.Header ?? []
  return [...headers]
    .sort((a, b) => a.Number - b.Number)
    .map((header) => ({
      value: header.AttribuutSelectorName,
      title: header.Name,
    }))
}